import styled from 'astroturf/react';
import { Body } from 'js/design_system/Body';
import { Heading } from 'js/design_system/Heading';
import _TitleText from "common-TitleText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/login_modal/pages/common.tsx?styleId=TitleText";
import _BodyText from "common-BodyText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/login_modal/pages/common.tsx?styleId=BodyText";
import _BodyTextSmall from "common-BodyTextSmall.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/login_modal/pages/common.tsx?styleId=BodyTextSmall";


export const TitleText = /*#__PURE__*/styled(Heading, null, {
  displayName: "TitleText",
  styles: _TitleText,
  attrs: props => ({
    ...props,
    size: 'md',
    fontFamily: 'serif'
  })
});

export const BodyText = /*#__PURE__*/styled(Body, null, {
  displayName: "BodyText",
  styles: _BodyText,
  attrs: props => ({
    ...props,
    size: 'xl',
    fontFamily: 'sans-serif'
  })
});

export const BodyTextSmall = /*#__PURE__*/styled(Body, null, {
  displayName: "BodyTextSmall",
  styles: _BodyTextSmall,
  attrs: props => ({
    ...props,
    size: 'sm',
    fontFamily: 'sans-serif'
  })
});
